module.exports = __webpack_public_path__ + "media/images/announceGroup__icon-4bb5be80b84d927f67ecddcb6d97f119.png";